import { TextField, MenuItem, Chip, Box } from "@mui/material";
interface Option {
  label: string;
  value: string;
}

interface FormInputProps {
  name?: string;
  label?: string;
  value: any;
  onChange: (value: any) => void;
  type?: string;
  select?: boolean;
  options?: Option[];
  multiple?: boolean;
  error?: boolean;
  helperText?: string;
  fullWidth?: boolean;
  inputRef?:any
}

const FormInputPage = ({
  label,
  value,
  onChange,
  type = "text",
  select = false,
  options = [],
  multiple = false,
  error = false,
  helperText = "",
  fullWidth = true,
  inputRef,
  ...rest
}: FormInputProps) => {
  return (
    <TextField
      label={label}
      type={type}
      value={value}
      select={select}
      error={error}
      helperText={helperText}
      inputRef={inputRef}
      fullWidth={fullWidth}
      onChange={(e) => onChange(e.target.value)}
      {...(select && {
        SelectProps: {
          multiple,
          renderValue: multiple
            ? (selected: any) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {(selected as string[]).map((value) => {
                    const option = options.find(
                      (o) => o.value === value
                    );
                    return (
                      <Chip
                        key={value}
                        label={option?.label || value}
                        size="small"
                      />
                    );
                  })}
                </Box>
              )
            : undefined,
        },
      })}
      {...rest}
    >
      {select &&
        options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
    </TextField>
  );
};

export default FormInputPage